import axios from "axios"
import { sortOrders, COMMENTS_LIMIT } from "@/constants/comments.js"

export const get = (id) => axios.get(`/api/v2/posts/${id}`)

export const searchPosts = ({ query, page }) =>
  axios.get("/api/v2/posts", {
    params: {
      query: `{ query: ${query} }`,
      page
    }
  })

export const deletePost = (id) => axios.delete(`/api/v1/posts/${id}`)

export const reportPost = (id, reason) => axios.post(`/api/v1/posts/${id}/reports`, { reason })

export const unpublishPost = (id) => axios.post(`/api/v2/posts/${id}/unpublish`)

export const togglePostPin = (id, pinnedUntil) => axios.put(`/api/v2/posts/${id}/pin`, { pinned_until: pinnedUntil })

export const togglePostCommenting = (id, commentingEnabled) => axios.put(`/api/v2/posts/${id}/commenting`, { commenting_enabled: commentingEnabled })

export const edit = (id, post) => axios.patch(`/api/v2/posts/${id}`, post)

export const prevComments = ({ id, cursor }) =>
  axios.get(`/api/v1/posts/${id}/comments`, {
    params: {
      after_timestamp: cursor,
      sort_order: sortOrders.DESCENDING,
      limit: COMMENTS_LIMIT
    }
  })

export const nextComments = ({ id, cursor }) =>
  axios.get(`/api/v1/posts/${id}/comments`, {
    params: {
      after_timestamp: cursor,
      sort_order: sortOrders.ASCENDING,
      limit: COMMENTS_LIMIT
    }
  })

export const like = (id) => axios.post(`/api/v1/posts/${id}/like`)

export const unlike = (id) => axios.delete(`/api/v1/posts/${id}/like`)

export const share = (id) => axios.post(`/api/v1/posts/${id}/post_share_links`)

export const addComment = (id, comment) => {
  return axios.post(`/api/v1/posts/${id}/comments`, comment)
}

export const add = (post, groupId) => {
  return axios.post("/api/v1/posts/", {
    ...post,
    wall: groupId,
    subscriber_only: false
  })
}

export const vote = (id) => axios.post(`/api/v1/polling/questions/${id}/vote`)

export const likingUsers = ({ id, page }) =>
  axios.get(`/api/v2/posts/${id}/liking_users`, {
    params: {
      page
    }
  })

export const badges = (ids) =>
  axios.get("/api/v2/posts/badges", {
    params: {
      ids
    }
  })

export const getNotificationBlock = (id) => axios.get(`/api/v1/posts/${id}/post_notification_block`)

export const setNotificationBlock = (id) => axios.post(`/api/v1/posts/${id}/post_notification_block`)

export const deleteNotificationBlock = (id) => axios.delete(`/api/v1/posts/${id}/post_notification_block`)

export const downloadAttachment = async ({ url, name }) => {
  const response = await axios.get(url, {
    responseType: "blob"
  })

  const blobUrl = window.URL.createObjectURL(new Blob([response]))
  const link = document.createElement("a")
  link.href = blobUrl
  link.setAttribute("download", name)
  document.body.appendChild(link)
  link.click()
  link.remove()
}
